var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bgContent"},[_c('div',{staticClass:"cont",style:({background:_vm.bg})},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view',{ref:"scroll",staticClass:"mainBox"}):_vm._e()],1),(!_vm.$route.meta.keepAlive)?_c('router-view',{ref:"scroll",staticClass:"mainBox"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }